import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../useAuth/AuthContext';
import { useURLParams } from '../../hooks/useURLParams';
import { useVodPurchasesQuery } from '../../hooks/useVodPurchasesQuery';

export const useVODPurchases = (forceFetch: boolean = false) => {
    const { isRentals } = useURLParams();
    const { isGuest, authApiInitialized } = useAuth();
    const queryClient = useQueryClient();

    const { data: vodPurchases, isLoading, refetch } = useVodPurchasesQuery(isRentals || forceFetch);

    const refreshVODPurchases = async (expectedAssetId?: string, retryCount = 0, maxRetries = 3) => {
        if (isGuest || !authApiInitialized) return;

        await new Promise<void>((resolve) => {
            setTimeout(resolve, 500);
        });

        const result = await refetch();
        const results = result.data?.results ?? [];
        const missing = expectedAssetId ? !results.some((purchase) => purchase.vod_asset?.id === expectedAssetId) : results.length === 0;

        if (missing && retryCount < maxRetries) {
            await new Promise<void>((resolve) => {
                setTimeout(resolve, 1000);
            });
            await refreshVODPurchases(expectedAssetId, retryCount + 1, maxRetries);
        }
    };

    const resetVODPurchases = () => {
        queryClient.resetQueries({ queryKey: ['vodPurchases'] });
    };

    return {
        vodPurchases,
        isLoading,
        refreshVODPurchases,
        resetVODPurchases,
    };
};
